

// MUI base styles
import typography from "../../base/typography";
import borders from "../../base/borders";
import colors from "../../base/colors";

// MUI helper functions
import pxToRem from "../../functions/pxToRem";

const { size, fontWeightMedium } = typography;
const { borderRadius } = borders;
const { dark } = colors;

const tab:any = {
  styleOverrides: {
      root:{
          textTransform: "none",
      }
  }
  //   root: {
  //     display: "flex",
  //     alignItems: "center",
  //     flexDirection: "row",
  //     flex: "1 1 auto",
  //     textAlign: "center",
  //     maxWidth: "unset !important",
  //     minWidth: "unset !important",
  //     minHeight: "unset !important",
  //     fontSize: size.xs,
  //     fontWeight: fontWeightMedium,
  //     textTransform: "none",
  //     lineHeight: "inherit",
  //     padding: pxToRem(4),
  //     borderRadius: borderRadius.md,
  //     color: `${dark.main} !important`,
  //     opacity: "1 !important",
  //
  //     "& .material-icons, .material-icons-round": {
  //       marginBottom: "0 !important",
  //       marginRight: pxToRem(4),
  //     },
  //
  //     "& svg": {
  //       marginBottom: "0 !important",
  //       marginRight: pxToRem(6),
  //     },
  //   },
  //
  //   labelIcon: {
  //     paddingTop: pxToRem(4),
  //   },
  // },
};

export default tab;
